import { BillingMethodEnum } from "@enums/billingMethodEnum.enum"
import { User } from "@models/identity/user"
import { Invoice } from "@models/invoice"
import { Transaction } from "@models/transaction"

export class InvoiceItemDto {
  id: number
  issuerUserId: string
  recipientUserId: string
  recipientUserFullName: string
  quantity: number
  unitPrice: number
  total: number
  createdAt: Date
  updatedAt: Date
  billingMethod: BillingMethodEnum
  startTimestamp: Date

}
